module.exports = __webpack_public_path__ + "static/media/Mail.45d5cb69.svg";